//const geojson_url = "https://storage.googleapis.com/mapsdevsite/json/google.json"; // for testing 

function renderStoreList(stores) {
  var storeListHTML = `
  <div id="nearby-stores-container">
  <p>${stores.length} Locations Nearby</p>
  <a href="https://www.amazon.com/s?k=Realeather+Crafts" target="_blank" type="button">Shop Online ></a>
  </div>
  `

  stores.forEach(store => {

    directionURL = new URL(`https://www.google.com/maps/dir/?api=1&travelmode=driving`)
    directionURL.searchParams.set('destination', `${store['Store Name']}, ${store.Address}, ${store.City}, ${store.State}`)
    
    var storePhoneNumberload = store.Telephone;
    var cleanedNumberload = ('' + storePhoneNumberload).replace(/\D/g, '');
    var numberMatchload = cleanedNumberload.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (numberMatchload) {
      var intlCodeload = (numberMatchload[1] ? '+1 ' : '');
      var storeNumberload = [intlCodeload, '(', numberMatchload[2], ') ', numberMatchload[3], '-', numberMatchload[4]].join('');
    }

    const newAddressload = `${store.City}, ${store.State}, ${store.Zip}`

    var storeLink = store.Website
    var websiteName = store.Website.replace(/https?:\/\//, '').replace(/\/$/, '')

    if (!store.Website.includes('http')) {
      storeLink = 'https://' + storeLink
    }

    storeListHTML = storeListHTML + `
    <div id="store-wrapper">
      <div class="store-details">
        <h3 id="store-heading">${store['Store Name']}</h3>
        <p id="store-address">${store.Address}
        <span style="display:block;">  ${newAddressload}</span>
        </p>
        
        <p id="store-contact">
          <a href="tel:${storeNumberload}">${storeNumberload}</a>
          <a href="${storeLink}">${websiteName}</a>
        </p>
      </div>
    <div class="direction-btn">
          <a href=${directionURL.toString()} target="_blank">directions</a>
        </div>
    </div>
    `

  })
  return storeListHTML
}

window.initMap = async () => {
  let directionURL;

  // create stores div
  
  const stores = document.createElement('div');
  stores.setAttribute('id','stores');
  const storesWrapper = document.createElement('div');
  storesWrapper.setAttribute('id','stores-wrapper');
  stores.appendChild(storesWrapper);
  stores.style.width = '100%';


  const storeList = await fetch(geojson_url).then(res => res.json())
  const map = await new google.maps.Map(document.getElementById('map'), {
    zoom: 5,
    center:  { lat: 38.010019, lng: -98.723170 }
  })
  
  storesWrapper.innerHTML = renderStoreList(storeList);

  const infoWindow = new google.maps.InfoWindow({
    content: "",
    disableAutoPain: true
  })

  // Build and add the search bar
  const card = document.createElement('div');
  const titleBar = document.createElement('div');
  const title = document.createElement('div');
  const container = document.createElement('div');
  const input = document.createElement('input');
  const inputLabel = document.createElement('label');

  card.setAttribute('id', 'pac-card');
  title.setAttribute('id', 'title');
  title.textContent = 'Buy Realeather Goods.';
  titleBar.appendChild(title);
  container.setAttribute('id', 'pac-container');
  input.setAttribute('id', 'pac-input');
  input.setAttribute('type', 'text');
  input.setAttribute('placeholder', 'Search by Zip or Address');

  inputLabel.setAttribute('id','input-label');
  inputLabel.innerHTML = `<svg fill="#000000" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="15px" height="15px"><path d="M 21 3 C 11.601563 3 4 10.601563 4 20 C 4 29.398438 11.601563 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601563 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z"/></svg>`

  container.appendChild(inputLabel);
  container.appendChild(input);
  card.appendChild(titleBar);
  card.appendChild(container);

  map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

  card.appendChild(stores);

  // Add markers
  const markers = storeList.map(store => {
    const position = {
      lat: store.Latitude,
      lng: store.Longitude
    }
    var label = "";

    // Add other stuff here to what happens when you click a location
    label += "<p>" + store['Store Name']
    label += "</p>"

    const marker = new google.maps.Marker({
      position
    });

    // ON MARKER CLICK

    marker.addListener('click', (e) => {

      infoWindow.open(map, marker);
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      const newStore = storeList.filter(el=>el.Longitude === lng && el.Latitude === lat)[0]

      directionURL = new URL(`https://www.google.com/maps/dir/?api=1&travelmode=driving`)
      directionURL.searchParams.set('destination', `${newStore['Store Name']}, ${newStore.Address}, ${newStore.City}, ${newStore.State}`)

      const newAddress = `${newStore.City}, ${newStore.State}, ${newStore.Zip}`

      // Phone Number format
      var phoneNumberString = newStore.Telephone;
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          var intlCode = (match[1] ? '+1 ' : '');
        var formattedPhoneNumber = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
      // Phone Number format

      infoWindow.setContent(`
      <div class="marker-details">
        <p class="name">${newStore['Store Name']}</p>
        <p>${newStore.Aaddress}</p>
        <p>${newAddress}</p>
        <p class="number">
          <a href="tel:${formattedPhoneNumber}">${formattedPhoneNumber}</a>
        </p>
        <p><a href=${directionURL.toString()} target="_blank" style="margin:3px 0;background-color: #00223A;color: #fff;padding: 5px;display:inline-block;">Directions</a></p>
      </div>
      `);

    });

    // add event listener for on click stuff here

    return marker;
  })

  new markerClusterer.MarkerClusterer({markers, map});

  // Make the search bar into a Places Autocomplete search bar and select
  // which detail fields should be returned about the place that
  // the user selects from the suggestions.

  const autocomplete = new google.maps.places.Autocomplete(input);
  autocomplete.setFields(["place_id", "geometry", "name"]);

  autocomplete.addListener('place_changed', async () => {
    const place = autocomplete.getPlace();
    
    // Recenter the map to the selected address
    map.setCenter(place.geometry.location);
    map.setZoom(9);

    // Use the markers that are in the bounds of the map to get distance to each store
    let inRangeMarkers = markers.filter(m => map.getBounds().contains(m.getPosition())).map(m => {
      m.distance = google.maps.geometry.spherical.computeDistanceBetween(map.getCenter(), m.getPosition())
      return m
    })

    // Filter stores that match nearby marker locations and sort by distance
    const nearbyStores = storeList.filter(
      store => 
        inRangeMarkers.findIndex(marker => {
          const pos = marker.getPosition()
          return pos.lng() === store.Longitude && pos.lat() === store.Latitude
        }) > -1
    ).map(store => {
      store.distance = inRangeMarkers.find(marker => {
        const pos = marker.getPosition()
        return pos.lng() === store.Longitude && pos.lat() === store.Latitude
      }).distance
      return store
    }).sort((a, b) => {
      return a.distance - b.distance
    })
      
    storesWrapper.innerHTML = renderStoreList(nearbyStores);
    
    if (!place.geometry) {
      // User entered the name of a Place that was not suggested and
      // pressed the Enter key, or the Place Details request failed.
      window.alert('No location available for input: \'' + place.name + '\'');
      return;
    }

    

    return;
  });

}
